<template>

  <ModalContainer queryParam="editLab" ref="modalContainer" size="lg">
    <b-card>
      <h4 class="text-center">Editar Item Laboratorio</h4>

      <b-form @submit.prevent="onUpdateLaboratorio" class="mt-2 row">
        
        <b-form-group label="Código:" label-for="codigo" class="col-6">
          <b-form-input
            id="codigo"
            v-model="laboratorio.codigo"
            type="text"
            required 
          />
        </b-form-group>
        

        <b-form-group label-for="area" class="col-6">
          <label>Area Analasis: <span class="text-danger">*</span></label>
          <validation-provider #default="{ errors }" name="area" rules="required">
            <v-select 
              id="area" v-model="laboratorio.area"
              placeholder="Buscar por area." 
              :options="areasa" 
              :reduce="option => option"
              label="text" 
              class="d-inline-block w-100" 
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>


        <b-form-group label="Descripcion:" label-for="descripcion" class="col-12">

          <b-form-input
            id="descripcion"
            v-model="laboratorio.descripcion"
            type="text"
            required 
          />

        </b-form-group>


        <hr class="col-12">

        <b-row class="col-12">
          <h6 class="col-12">Precio:</h6>

          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 100px;">ISSFA N1</label>
            <InputNumber v-model="laboratorio.precios.issfa_n1" decimal/>
          </div>

          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 100px;">ISSFA N2</label>
            <InputNumber v-model="laboratorio.precios.issfa_n2" decimal/>
          </div>


          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 100px;">IESS N1</label>
            <InputNumber v-model="laboratorio.precios.iess_n1" decimal/>
          </div>

          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 100px;">PARTICULAR</label>
            <InputNumber v-model="laboratorio.precios.particular" decimal/>
          </div>


          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 100px;">ISSPOL N1</label>
            <InputNumber v-model="laboratorio.precios.isspol_n1" decimal/>
          </div>

        </b-row>

        <hr class="col-12">

        <b-row class="col-12">
          <h6 class="col-12">Estado:</h6>

          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 80px;">IESS</label>

            <b-form-checkbox 
              v-model="laboratorio.estados.iess" 
              switch
            />
          </div>

          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 80px;">ISSFA</label>

            <b-form-checkbox 
              v-model="laboratorio.estados.issfa" 
              switch
            />
          </div>


          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 80px;">ISSPOL</label>

            <b-form-checkbox 
              v-model="laboratorio.estados.isspol" 
              switch
            />
          </div>

          <div class="col-6 d-flex align-items-center mb-1">
            <label for="" class="mb-0 mr-2" style="width: 80px;">PARTICULAR</label>

            <b-form-checkbox 
              v-model="laboratorio.estados.particular"
              switch
            />
          </div>
        </b-row>

        <div class="col-12 d-flex justify-content-end mt-3">
          <b-button type="submit" variant="primary" class="mx-2">
            Actualizar laboratorio
          </b-button>

          <b-button @click="onCancel" variant="danger">
            Cancelar
          </b-button>
        </div>
        
      </b-form>
    </b-card>
  </ModalContainer>
  
  
</template>
  
<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate';
import { required } from '@validations'
import { ModalContainer, InputNumber } from '@/shared/components'
import { carteraLaboratorioService } from './services';
  
export default {

  name: 'EditarLaboratorio',

  components: {
    ValidationProvider,
    vSelect,
    ModalContainer,
    InputNumber
  },


  data() {
    return {
      required,
      localIsVisible: false,

      establecimientos: [],
      areasa: [],

      laboratorio: {
        id: '',
        token:'',
        descripcion: '',
        codigo: '',
        precio: 0,
        area:'',
        establecimiento: '',
        areasa: [],

        precios: {
          
        },
        estados: {
          issfa: 0,
          iess: 0,
          isspol: 0,
          particular: 0
        },
      },
    };
  },

  created() {
    this.getData();
    this.fetchEstablecimientos();
    this.fetchAreaAnalisis();

  },

  methods: {

    onCancel() {
      this.localIsVisible = false
    },


    async onUpdateLaboratorio(){

      // const precioNetoFormateado = parseFloat(this.laboratorio.precio).toFixed(4);

      const laboratorioToUpdate = {
        id              : this.laboratorio.id,
        establecimiento : this.laboratorio.establecimiento,
        descripcion     : this.laboratorio.descripcion,
        codigo          : this.laboratorio.codigo,
        area            : this.laboratorio.area?.value,
        estados         : this.laboratorio.estados ? JSON.stringify(this.laboratorio.estados) : null,
        precios         : this.laboratorio.precios ? JSON.stringify(this.laboratorio.precios) : null
      }


      if(!laboratorioToUpdate.estados){
        console.error('no hay dato de estados en el laboratorio a actualizar');
        return;
      }

      if(!laboratorioToUpdate.precios){
        console.error('no hay dato de precios en el laboratorio a actualizar');
        return;
      }
      
      const responseUpdate = await carteraLaboratorioService.updateItem(laboratorioToUpdate);

      if(!responseUpdate) {
        await this.$swal({
          icon: 'error',
          title: 'No se pudo actualizar el laboratorio',
          showConfirmButton: true,
        });

        return;
      }

      await this.$swal({
        icon: 'success',
        title: 'Laboratorio actualizado',
        showConfirmButton: true,
      })

      this.$router.go(0);
    },



    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value    : item.id,
          text     : item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },


    async fetchAreaAnalisis() {
      const query = `
        query obtenerAreaAnalisis {
          allAreaslab {
            descripcion
            id
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.areasa = response.data.data.allAreaslab.map(item => ({
          value: item.id,
          text: item.descripcion
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },


    async getData() {
      const tokenLab = this.$route.query.editLab;

      const params = {
        tokenLab: tokenLab
      };

      const response = await carteraLaboratorioService.getAll( params );
      if(!response || !response.laboratorios) return;

      const laboratorio = response.laboratorios[0];

      const areaAnalisis = {
        value: laboratorio.areaanalisis.id,
        text : laboratorio.areaanalisis.descripcion
      }

      const estados  = laboratorio.estadoJson ? JSON.parse(laboratorio.estadoJson) : {};
      const precios = laboratorio.precioJson ? JSON.parse(laboratorio.precioJson) : {};

      const laboratorioMap = {
        id              : laboratorio.id,
        token           : laboratorio.token,
        establecimiento : laboratorio.establecimiento.id,
        descripcion     : laboratorio.descripcion,
        codigo          : laboratorio.codigo,
        precio          : laboratorio.precio,
        area            : areaAnalisis,
        estados         : estados,
        precios         : precios
      };

      this.laboratorio = laboratorioMap;

    },
  },

  watch: {

    '$route.query.editLab': {
      deep: true,
      handler(newValue) {
        if(newValue) this.getData();
      }
    },


    laboratorio: {
      deep: true,
      handler(newValue) {
        if(newValue) console.log("laboratorio", newValue)
      }
    },

  }
};
</script>

  